// @ts-nocheck

import { match as MatchUtils } from '..';
import { __ } from '../../i18n/l10n';
import { MatchEntity } from '../../states/entities/matches';
import type { ScoreboardProps, SecondariesScoreType, ScorersType } from '../../states/scoreboards';
import { getExtendedMinuteStringFromMatchTime } from '../date';

export const computeScorers = (scorers: Array<unknown> = [], side: string): ScorersType => {
  const hasAtLeastOneScorerName = scorers?.filter(({ player }) => player !== '').length > 0;

  // We don't display scorers if we receive only goal times without any scorer name
  // We also remove TAB scorers (time !== -1)

  return hasAtLeastOneScorerName
    ? scorers.reduce((acc, scorer) => {
        const { scoringTeam, time, player, stoppageTime, ownGoal, penalty } = scorer;
        if (
          scoringTeam !== undefined &&
          scoringTeam !== null &&
          scoringTeam === side &&
          time !== undefined &&
          time !== null &&
          time !== -1 &&
          player
        ) {
          const formattedTime = getExtendedMinuteStringFromMatchTime(time, stoppageTime);

          let detail = '';
          if (penalty) {
            detail = ` (${__('penalty')})`;
          } else if (ownGoal) {
            detail = ` (${__('own goal')})`;
          }

          return [
            ...acc,
            {
              player: player,
              time: formattedTime,
              detail: detail.length > 0 ? detail : undefined,
            },
          ];
        } else {
          return acc;
        }
      }, [])
    : [];
};

export const computeSecondaryScores = (scores: Array<string>): SecondariesScoreType => {
  const finalScores = [];

  if (scores.length > 1) {
    finalScores.unshift({
      label: __('!short:HalfTime'),
      score: scores[0].split(':'),
    });
  }
  if (scores.length > 2) {
    finalScores.unshift({
      label: __('!short:RegularTime'),
      score: [MatchUtils.computeScore(scores, 0, 2), MatchUtils.computeScore(scores, 1, 2)],
      isReg: true,
    });
  }
  // For matchs with TABS and without OT, we don't display TABS separatly
  // They are in the main score
  // Due to the fact that data comes like this: MT1 - MT2 - TAB - 0:0 instead of MT1 - MT2 - 0:0 - TAB
  const psoScore = MatchEntity.getPsoScore(scores);
  if (psoScore) {
    finalScores.unshift({
      label: __('!short:PenaltyShootOut'),
      score: psoScore,
      isActive: true,
      isPso: true,
    });
  }

  return finalScores;
};

export default (
  {
    sportId,
    matchId,
    period,
    periodName,
    setScores,
    competitor1Name,
    competitor1Flag,
    yellowRedCardsHome = 0,
    redCardsHome = 0,
    competitor2Name,
    competitor2Flag,
    yellowRedCardsAway = 0,
    redCardsAway = 0,
    scorers,
  }: unknown,
  fromBetBuilder: boolean,
): ScoreboardProps => {
  let scores = null;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  return {
    matchId,
    period: periodName || MatchUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: competitor1Name,
        flag: competitor1Flag,
        nbRedCards: yellowRedCardsHome + redCardsHome,
        scorers: computeScorers(scorers, 'home'),
      },
      {
        name: competitor2Name,
        flag: competitor2Flag,
        nbRedCards: yellowRedCardsAway + redCardsAway,
        scorers: computeScorers(scorers, 'away'),
      },
    ],
    scores: {
      main: {
        score: scores ? [MatchUtils.computeScore(scores, 0, 3), MatchUtils.computeScore(scores, 1, 3)] : ['', ''],
        isActive: scores ? scores.length < 5 : false,
      },
      secondaries: scores ? computeSecondaryScores(scores) : [],
    },
    expandThreshold: fromBetBuilder ? 2 : 5,
  };
};
